import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "clear_jar",
    image: "clear_jar",
    type: "interactableObject",
    states: [
      {
        name: "Closed",
        image: "clear_jar",
        altText: "Clear jar with the lid closed.",
      },
      {
        name: "Open",
        image: "clear_jar_open",
        altText: "Clear jar with the lid open.",
      },
    ],
  },
  {
    name: "small_clear_jar",
    image: "small_clear_jar",
    type: "interactableObject",
    states: [
      {
        name: "Closed",
        image: "small_clear_jar",
        altText: "Small clear jar with the lid closed.",
      },
      {
        name: "Open",
        image: "small_clear_jar_open",
        altText: "Small clear jar with the lid open.",
      },
    ],
  },
  {
    name: "brown_glass_tube",
    image: "empty_substrate_corked",
    type: "interactableObject",
    states: [
      {
        name: "ClosedEmpty",
        image: "empty_substrate_corked",
        altText: "Empty glass tube with the lid closed.",
        buttons: [
          {
            title: "Remove lid",
            icon: "remove_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenEmpty",
              },
            ],
          },
        ],
      },
      {
        name: "OpenEmpty",
        image: "empty_substrate",
        altText: "Empty glass tube with the lid open.",
        buttons: [
          {
            title: "Put lid",
            icon: "add_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedEmpty",
              },
            ],
          },
        ],
      },
      {
        name: "ClosedTiniest",
        image: "tiniest_substrate_corked",
        altText:
          "Glass tube with a tiny amount of substrate and the lid closed.",
        buttons: [
          {
            title: "Remove lid",
            icon: "remove_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenTiniest",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenTiniest",
        image: "tiniest_substrate",
        altText: "Glass tube with a tiny amount of substrate and the lid open.",
        buttons: [
          {
            title: "Put lid",
            icon: "add_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedTiniest",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "ClosedTiny",
        image: "tiny_substrate_corked",
        altText:
          "Glass tube with a small amount of substrate and the lid closed.",
        buttons: [
          {
            title: "Remove lid",
            icon: "remove_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenTiny",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenTiny",
        image: "tiny_substrate",
        altText:
          "Glass tube with a small amount of substrate and the lid open.",
        buttons: [
          {
            title: "Put lid",
            icon: "add_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedTiny",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "ClosedHalf",
        image: "half_substrate_corked",
        altText:
          "Glass tube with half the volume filled with substrate and the lid closed.",
        buttons: [
          {
            title: "Remove lid",
            icon: "remove_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenHalf",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenHalf",
        image: "half_substrate",
        altText:
          "Glass tube with half the volume filled with substrate and the lid open.",
        buttons: [
          {
            title: "Put lid",
            icon: "add_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedHalf",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "ClosedFull",
        image: "full_substrate_corked",
        altText:
          "Glass tube completely filled with substrate and the lid closed.",
        buttons: [
          {
            title: "Remove lid",
            icon: "remove_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "OpenFull",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
      {
        name: "OpenFull",
        image: "full_substrate",
        altText:
          "Glass tube completely filled with substrate and the lid open.",
        buttons: [
          {
            title: "Put lid",
            icon: "add_stopper",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "ClosedFull",
              },
            ],
          },
          {
            title: "Inspect Tube",
            icon: "InspectTubeIcon",
            type: "Modal",
            modal: "InspectTubeModal",
          },
        ],
      },
    ],
  },
  {
    name: "brown_jar",
    image: "brown_jar",
    type: "interactableObject",
    states: [
      {
        name: "Closed",
        image: "brown_jar",
        altText: "Brown jar with the lid closed.",
      },
      {
        name: "Open",
        image: "brown_jar_open",
        altText: "Brown jar with the lid open.",
      },
    ],
  },
  {
    name: "microplate_reader",
    image: "microplate_reader_off",
    type: "compositeInteractableObject",
    states: [
      {
        name: "reader_on_closed",
        image: "microplate_reader_on",
        altText: "Microplate reader with the door closed and powered on.",
        buttons: [
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_closed",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_open",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_result_open",
        image: "microplate_reader_off",
        altText: "Microplate reader with the door open and powered off.",
        buttons: [
          {
            title: "Eject",
            icon: "eject_microplate",
            type: "UpdateState",
            actionName: "REMOVE_PLATE_FROM_READER",
            stateUpdates: [
              {
                nextState: "reader_on_open",
              },
              {
                objectId: "microplate",
                nextState: "21FilledResult",
              },
            ],
          },
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_result_open",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_result_closed",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_on_result_open",
        image: "microplate_reader_on",
        altText: "Microplate reader with the door open and powered on.",
        buttons: [
          {
            title: "Eject",
            icon: "eject_microplate",
            type: "UpdateState",
            actionName: "REMOVE_PLATE_FROM_READER",
            stateUpdates: [
              {
                nextState: "reader_on_open",
              },
              {
                objectId: "microplate",
                nextState: "21FilledResult",
              },
            ],
          },
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_result_open",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_result_closed",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open_completed_plate",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_result_closed",
        image: "microplate_reader_off",
        altText: "Microplate reader with the door closed and powered off.",
        buttons: [
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_result_closed",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_result_open",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_on_result_closed",
        image: "microplate_reader_on",
        altText: "Microplate reader with the door closed and powered on.",
        buttons: [
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_result_closed",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_result_open",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_on_open",
        image: "microplate_reader_on",
        altText: "Microplate reader with the door open and powered on.",
        buttons: [
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_open",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_closed",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_on_open__21filled_plate",
        image: "microplate_reader_on",
        altText:
          "Microplate reader with the door open and powered on, with a microplate inside.",
        buttons: [
          {
            title: "Eject",
            icon: "eject_microplate",
            type: "UpdateState",
            actionName: "REMOVE_PLATE_FROM_READER",
            stateUpdates: [
              {
                nextState: "reader_on_open",
              },
              {
                objectId: "microplate",
                nextState: "21Filled",
              },
            ],
          },
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_open__21filled_plate",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_closed__21filled_plate",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open_21filled_plate",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_on_closed__21filled_plate",
        image: "microplate_reader_on",
        altText:
          "Microplate reader with the door closed and powered on, with a microplate inside.",
        buttons: [
          {
            title: "Configure",
            icon: "ConfigApparatusIcon",
            type: "Modal",
            modal: "MicroplateReaderFocusModal",
          },
          {
            title: "Turn off",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_closed__21filled_plate",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_open__21filled_plate",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_open__21filled_plate",
        image: "microplate_reader_off",
        altText:
          "Microplate reader with the door open and powered off, with a microplate inside.",
        buttons: [
          {
            title: "Eject",
            icon: "eject_microplate",
            type: "UpdateState",
            actionName: "REMOVE_PLATE_FROM_READER",
            stateUpdates: [
              {
                nextState: "reader_off_open",
              },
              {
                objectId: "microplate",
                nextState: "21Filled",
              },
            ],
          },
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_open__21filled_plate",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_closed__21filled_plate",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open_21filled_plate",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_closed__21filled_plate",
        image: "microplate_reader_off",
        altText:
          "Microplate reader with the door closed and powered off, with a microplate inside.",
        buttons: [
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_closed__21filled_plate",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_open__21filled_plate",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_closed",
        image: "microplate_reader_off",
        altText: "Microplate reader with the door closed and powered off.",
        buttons: [
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_closed",
              },
            ],
          },
          {
            title: "Open",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_open",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_closed",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
      {
        name: "reader_off_open",
        image: "microplate_reader_off",
        altText: "Microplate reader with the door open and powered off.",
        buttons: [
          {
            title: "Turn on",
            icon: "off_icon",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_on_open",
              },
            ],
          },
          {
            title: "Close",
            icon: "",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "reader_off_closed",
              },
            ],
          },
        ],
        objects: [
          {
            door: "microplate_reader_door_open",
            power_button: "microplate_reader_power_button",
          },
        ],
      },
    ],
  },
  {
    name: "microplate",
    image: "microplate",
    type: "controllableObject",
    modals: ["MicroplateFocusModal"],
    buttons: [
      {
        title: "View plate",
        icon: "EyeIcon",
        type: "Modal",
        modal: "MicroplateFocusModal",
      },
    ],
    states: [
      {
        name: "hidden_on_drop",
        image: "",
      },
      {
        name: "Empty",
        image: "microplate",
        altText: "Empty 96-well microplate.",
      },
      {
        name: "1Filled",
        image: "microplate_1_filled",
        altText: "96-well microplate with 1 well filled.",
      },
      {
        name: "21Filled",
        image: "microplate_21_filled",
        altText: "96-well microplate with 21 wells filled.",
      },
      {
        name: "21FilledResult",
        image: "microplate_21_filled_result",
        altText:
          "96-well microplate with 21 wells filled and the result displayed.",
      },
    ],
  },
  {
    name: "enzyme_cupboard",
    image: "enzyme_cupboard",
    type: "interactableObject",
    states: [
      {
        name: "default",
        image: "enzyme_cupboard",
        altText: "Enzyme cupboard with tubes.",
      },
      {
        name: "empty",
        image: "enzyme_cupboard_no_tubes",
        altText: "Empty enzyme cupboard.",
      },
    ],
  },
];

export default objects;
